import { render, staticRenderFns } from "./template.vue?vue&type=template&id=32a830c9&scoped=true&"
import script from "./template.vue?vue&type=script&lang=js&"
export * from "./template.vue?vue&type=script&lang=js&"
import style0 from "./template.vue?vue&type=style&index=0&id=32a830c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../agent-app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a830c9",
  null
  
)

export default component.exports